import { configureStore } from "@reduxjs/toolkit";

import shopReducer from "./slices/shopSlice";
import cartReducer from "./slices/cartSlice";
import settingsReducer from "./slices/settings";
import userSlice from "./slices/userSlice";
import categorySlice from "./slices/categorySlice";

// Configure the Redux store reducers and custom middleware.
export const store = configureStore({
  reducer: {
    shopslice: shopReducer,
    cartSlice: cartReducer,
    settings: settingsReducer,
    userSlice : userSlice,
    categorySlice: categorySlice
  },
});
